import React, { Component } from 'react';
import Constants from '../../Config/Config';

class Printing extends Component {

	componentDidUpdate(prevProps, prevState) {
  	if (prevProps.selectedPrint !== this.props.selectedPrint || prevProps.frameFullDimension !== this.props.frameFullDimension) {
      this.getSelectedPrint();
  	}
	}

  getSelectedPrint = () => {
    const {printing, selectedPrint, frameFullDimension} = this.props;
    if (printing.size > 0 && selectedPrint !== null) {
      printing.filter( ( print ) =>
        parseFloat(selectedPrint) === print.get('id')
      ).map( ( print ) =>
        this.props.dispatch({
          type: 'SET_STATE',
          state: {
            printTotal: ( frameFullDimension * parseFloat(print.getIn(['acf', 'price'])) ).toFixed(2),
            selectedPrintName: print.getIn(['title', 'rendered'])
          }
        })
      )
    }
  };
    
	render() {
		const {printTotal, selectedPrintName} = this.props;
    return (
      <tr> 
  			<th>Printing</th> 
  			<td>{selectedPrintName}</td> 
  			<td>{Constants.Currency + printTotal}</td> 
      </tr>
    );
	}
}

export default Printing;